import { featuresItems } from '@/mocks/home';

export default function FeaturesSection() {
  return (
    <section id="features" className="py-10 md:py-14 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 text-center mb-8">
          平台特色
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5">
          {featuresItems.map((item) => (
            <div
              key={item.id}
              className="bg-background-50 rounded-lg p-5 border border-background-200/70 text-center group hover:border-primary-300 transition-all duration-300"
            >
              <span className="w-12 h-12 flex items-center justify-center mx-auto mb-3 rounded-full bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-300">
                <i className={`${item.icon} text-xl`}></i>
              </span>
              <h3 className="text-sm font-semibold text-foreground-900 mb-2">{item.title}</h3>
              <p className="text-xs text-foreground-600 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}